import { createFormItem } from "@/component-create/utils/create-form-item"
import { FormDialog } from "@/component-create/FormDialog"
import { FORM_ITEM } from "@/components/form/enums"

import MenuSelect from '@/views/components/MenuSelect.vue'

import XIconSelect from '@/components/x-icon-select/XIconSelect.vue'
import { BASE_URL } from "@/api/system/menu"

let addForm: FormDialog | null = null

/**
 * 绘制新增表单
 */
 export function renderEditForm(el: Element) {
  addForm = new FormDialog(
    el, 
    { 
      items: items, 
      elFormProps: { rules: rules }, 
      saveUrl: BASE_URL,
      loadUrl: BASE_URL,
      saveMethods: 'put'
    },
    '编辑'
  )

  return addForm
}

const items = [
  [
    createFormItem('上级目录', 'parentId', MenuSelect)
  ],
  [
    createFormItem('菜单名称', 'menuName', FORM_ITEM.INPUT, { maxlength: '30' })
  ],
  [
    createFormItem('路由地址', 'path', FORM_ITEM.INPUT, { maxlength: '100' })
  ],
  [
    createFormItem('组件路径', 'component', FORM_ITEM.INPUT, { maxlength: '100' })
  ],
  [
    createFormItem('菜单图标', 'icon', XIconSelect),
    createFormItem('菜单类型', 'menuType', FORM_ITEM.SELECT, { loader: 'MENU_TYPE', disabled: true }),
  ],
  [
    createFormItem('显示顺序', 'sort', FORM_ITEM.INPUT_NUMBER, { controlsPosition: 'right', min: 0, max: 1000 }),
    createFormItem('显示状态', 'visible', FORM_ITEM.SELECT, { loader: 'MENU_VISIBILITY', default: true }),
  ],
  [
    createFormItem('缓存状态', 'keepAlive', FORM_ITEM.SELECT, { loader: 'MENU_KEEP_ALIVE', default: true, disabled: false }),
    createFormItem('菜单状态', 'status', FORM_ITEM.SELECT, { loader: 'MENU_STATUS', default: true }),
  ],
  [
    createFormItem('备注', 'remark', FORM_ITEM.INPUT, { type: 'textarea', rows: 3, maxlength: '200', showWordLimit: true }),
  ]
]

const rules = {
  menuName: [{ required: true, message: '请输入菜单名称', trigger: 'blur' }],
  actionName: [{ required: true, message: '请输入操作名称', trigger: 'blur' }],
  path: [{ required: true, message: '请输入路由地址', trigger: 'blur' }],
  component: [{ required: true, message: '请输入组件路径', trigger: 'blur' }],
  authorityCode: [{ required: true, message: '请输入权限代码', trigger: 'blur' }]
}